import React from 'react';
import AddActivity from './AddActivity';

export default () => <AddActivity />;
